import styled from 'styled-components';

/**
 * Horizontal gray line for separating content.
 */
const Hairline = styled.div<{ $marginTop?: string; $marginBottom?: string; $color?: string }>`
  margin: ${({ $marginTop = '24px', $marginBottom = '24px' }) => `${$marginTop} 0 ${$marginBottom}`};
  height: 1px;
  width: 100%;
  background-color: ${({ $color = 'var(--grayscale-100)' }) => $color};
`;

export default Hairline;
